import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource, Sort, PageEvent, MatExpansionPanel, MatDialog, MatSort, MatSnackBar } from '@angular/material';
import { Contacto, TipoContacto } from '../../../interfaces/contacto';
import { ContactoService } from '../../../providers/contacto.service';
import { ComunicacionService } from '../../../providers/comunicacion.service';
import * as moment from 'moment';
import { switchMap } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import { FormatDatePipe } from '../../../pipes/transforms/format-date.pipe';
import { Entidad } from '../../../interfaces/entidad';
import { c } from '@angular/core/src/render3';
// import { OrdenEstadoPropuestaDialog } from '../ordenar-estados-propuesta/ordenar-estado-propuesta-dialog.component';

@Component({
  selector: 'app-ver-contactos',
  templateUrl: './ver-contactos.component.html',
  styleUrls: ['./ver-contactos.component.scss']
})
export class VerContactosComponent implements OnInit {
  readonly titulo = 'contactos';
  tablaContactosColumnas = ['nombre', 'apellido','tipoContacto', 'asociado_a', 'cargo', 'curso', 'email', 'celular', 'telefono','localidad','categoria', 'acciones'];
  sort: Sort = { active: '', direction: '' };
  page: PageEvent = new PageEvent();
  filtros: any = {
    generico: '',
    nombre: '',
    apellido:'',
    tipoContacto: '',
    asociado_a: '',
    curso: '',
    cargo:'',
    email: '',
    telefono: '',
    localidad:'',
    clasificacionEntidad: '',
    mostrar_todo: true
  };
  title = "Contactos";
  descargandolistado: boolean = false;
  cargando: boolean;
  @Output() formState = new EventEmitter(); // emite el estado del formulario
  actualizarTablaTimeout: any; // prevenir muchos llamados consecutivos al webserver
  flag_primera_carga: boolean = true; // primera solicitud a traer datos
  cargandoTimeout: any;
  cargandoTiposCliente: boolean = false;
  tiposContacto: TipoContacto[] = [];  
  contactosDataSource = new MatTableDataSource();
  contactos: Contacto[] = <Contacto[]>[];
  tieneFiltrosOrdenPaginado = false;
  panelConFiltroActivo = false;
  total: number;
  @Input() acciones: boolean = false; // true para mostrar las acciones de ABM etc...
  @Input() conFiltro: boolean = false; // mostrar u ocultar el input de filtros.
  @Input() conSort: boolean = false; // mostrar u ocultar el sort en la columna.
  @Output() onChange = new EventEmitter();
  @ViewChild(MatSort) matSort: MatSort;
  @ViewChild('filtrosPanel') set filtrosPanel(v: MatExpansionPanel) {
    if (typeof v != 'undefined') {
      setTimeout(() => {
        this.checkPageState();
        if (this.panelConFiltroActivo) {
          v.open();
        }
      }, 0);
    }
  };

  constructor(
    // private permisoService: PermisoService
    private contactoService: ContactoService,
    private _cmSv: ComunicacionService,
    private snackBar: MatSnackBar,
    private datePipe: FormatDatePipe,
  ) { }
  @Input('filtrado') filtrado: boolean = true;
  ngOnInit() {
    this.actualizarTabla();
    this.tiposContacto = [];
    this.contactoService.getTiposContacto().subscribe(
      respuesta => {
        // console.log('Respuesta TipoContactos', respuesta.data.tiposContacto);
        if (respuesta.estado == 1 && respuesta.data) {
          if (respuesta.data.tiposContacto) {
            respuesta.data.tiposContacto.forEach(tipoContacto => {
              this.tiposContacto.push(<TipoContacto>{
                IdTipoContacto: tipoContacto.IdTipoContacto,
                descripcion: tipoContacto.TipoContactoDesc
              });
            });
          }
        } else {
          this.formState.emit({ // error al buscar datos
            estado: 3,
            mensaje: 'El contacto no podrá ser asignado'
          });
        }        
      },
      error => {   

        this.formState.emit({ // error al buscar datos
          estado: 2,
          mensaje: error
        });
      }
    );
  }

  _limpiarPageState() {
    // console.log('PAso B');
    // filtros
    localStorage.setItem('ver_contactos_filtros', null);
    // paginado
    localStorage.setItem('ver_contactos_paginado', null);
    // sort
    localStorage.setItem('ver_contactos_sort', null);
  }

  recordarPageState() {
    // filtros
    localStorage.setItem('ver_contactos_filtros', JSON.stringify(this.filtros));
    // paginado
    localStorage.setItem('ver_contactos_paginado', JSON.stringify(this.page));
    // sort
    localStorage.setItem('ver_contactos_sort', JSON.stringify(this.sort));
  }


  getLocalidad(contacto: any): string {
    const entidad = contacto.entidad;
    const valores = [
      entidad.provinciaEntidad,
      entidad.localidadEntidad,
      entidad.paisEntidad
    ].filter(value => !!value); // Filtramos solo valores definidos
  
    return valores.length ? valores.join(', ') : 'sin localidad'; // Retorna los valores con coma o 'sin localidad'
  }
  checkPageState(): boolean {
    this.tieneFiltrosOrdenPaginado = false;
    // checkear si hay almenos un filtro aplicado
    this.panelConFiltroActivo = false;
    for (let propiedad in this.filtros) {
      if(propiedad != 'mostrar_todo'){
        if (this.filtros[propiedad]) {
          this.tieneFiltrosOrdenPaginado = true;
          this.panelConFiltroActivo = true;
          break;
        }
      }
    }
    // checkear si hay paginado
    if (this.page.pageIndex != 0) {
      this.tieneFiltrosOrdenPaginado = true;
    }
    // checkear si hay ordenamiento
    if (this.sort.active != '' && (this.sort.active != 'fechaModificacion' || this.sort.direction != 'desc')) {
      this.tieneFiltrosOrdenPaginado = true;
    }
    return this.tieneFiltrosOrdenPaginado;
  }

  restaurarPageState() {
    // console.log('PAso C');
    // filtros
    let localFiltros = JSON.parse(localStorage.getItem('ver_contactos_filtros'));
    if (localFiltros != null) {
      this.filtros = localFiltros;
    } else {
      for (let propiedad in this.filtros) {
        this.filtros[propiedad] = '';
      }
    }
    // paginado
    let localPaginado = JSON.parse(localStorage.getItem('ver_contactos_filtros'));
    if (localPaginado != null) {
      this.page = localPaginado;
    } else {
      this.page.pageIndex = 0;
      this.page.pageSize = +localStorage.getItem('ver_contactos_paginado_size') || 10;
      this.page.length = 0;
    }
    // sort
    // let localSort = JSON.parse(localStorage.getItem('ver_contactos_sort'));
    // if (localSort != null) {
    //   // para el sort tenemos que hacerlo con un "set" porque arregla un bug de "matSort"
    //   this.setActiveSortProgrammatically(localSort.active, localSort.direction);
    // } else {
    //   this.setActiveSortProgrammatically('IdContacto', 'desc');
    // }
    // this.actualizarTabla();
  }

  /**
 * Para arreglar un bug de angular usamos esta funcion para ordenar
 */
  setActiveSortProgrammatically(active, direction): void {
    let interval = setInterval(() => {
      if (this.matSort) {
        clearInterval(interval);
        if (this.sort.active != active || this.sort.direction != direction) {
          this.sort = <MatSort>{
            active: active,
            direction: direction
          };
          this.matSort.sort({
            id: active,
            start: direction,
            disableClear: true
          });
          // ugly hack!
          const activeSortHeader = this.matSort.sortables.get(active);
          if (activeSortHeader) {
            activeSortHeader['_setAnimationTransitionState']({
              fromState: direction,
              toState: 'active'
            });
          }
        }
      }
    }, 0);
  }

  sortData(sort: Sort) {
    this.sort = sort;
    this.actualizarTabla();
  }

  onPage(pageEvent: PageEvent) {
    localStorage.setItem('ver_' + this.titulo + '_paginado_size', pageEvent.pageSize.toString());
    this.page = pageEvent;
    this.actualizarTabla();
  }

  // get todas las propieades de un objeto (y sus sub objetos) en un objeto plano
  flattenObject = function (ob) {
    var toReturn = {};

    for (var i in ob) {
      if (!ob.hasOwnProperty(i)) continue;

      if ((typeof ob[i]) == 'object') {
        var flatObject = this.flattenObject(ob[i]);
        for (var x in flatObject) {
          if (!flatObject.hasOwnProperty(x)) continue;
          toReturn[i + '.' + x] = flatObject[x];
        }
      } else {
        toReturn[i] = ob[i];
      }
    }

    return toReturn;
  };


  reiniciarPageState() {
    // this.contactos = [];
    this.actualizarTabla();
    this._limpiarPageState();
    this.restaurarPageState();
  }
  contactoCreado(evento: any) { // agregar dato creado al listado
    if (evento && evento.contacto) {
      let contacto = <Contacto>evento.contacto;
      this.contactos.unshift(new Contacto(
        contacto.apellido,
        contacto.cargo,
        contacto.celularCodigoPais,
        contacto.celularCodigoArea,
        contacto.celularNumero,
        contacto.email,
        <Entidad>{
          IdEntidad: contacto.entidad.IdEntidad,
          razonSocial: contacto.entidad.razonSocial
        },
        contacto.examen,
        contacto.fechaAlta,
        contacto.fechaCertificacion,
        contacto.fechaModificacion,
        contacto.dia_nacimiento,
        contacto.mes_nacimiento,
        contacto.fechaUltimaCertificacion,
        contacto.usuarioModificacion,
        contacto.idContacto,
        contacto.interno,
        contacto.kit,
        contacto.nombre,
        contacto.pago,
        contacto.perfil,
        contacto.razonSocial,
        contacto.telefonoCodigoPais,
        contacto.telefonoCodigoArea,
        contacto.telefonoNumero,
        <TipoContacto>{
          IdTipoContacto: contacto.tipoContacto.IdTipoContacto,
          tipoContactoDesc: contacto.tipoContacto.tipoContactoDesc
        },
      ));
      this.contactosDataSource.data = this.contactos;
      this.onChange.emit();
    }
  }

  contactoEliminado(index: any) { // quitar del listado según el index
    this.contactos.splice(index, 1);
    this.contactosDataSource.data = this.contactos;
    this.onChange.emit();
  }

  contactoEditado(index: any, evento: any) { // editar el dato según el index y los datos
    this.contactos[index] = <Contacto>evento.contacto;
    this.contactosDataSource.data = this.contactos;
    this.onChange.emit();
  }

  setContactos(contactos: Contacto[]): void { // actualizar listado
    this.contactos = contactos;
    this.contactosDataSource.data = this.contactos;
    this.onChange.emit();
  }

  setCargando(cargando: boolean = true): void { // cambiar el estado de la barra de cargando
    this.cargando = cargando;
  }

  actualizarTabla(): void {
    this.cargando = true;
    this.contactos = [];
    // this.page.pageIndex = 0;
  
    // Recorre los filtros y aplica trim() a cada valor
    const cleanFiltros:any = Object.keys(this.filtros).reduce((acc, key) => {
      acc[key] = typeof this.filtros[key] === 'string' ? this.filtros[key].trim() : this.filtros[key];
      return acc;
    }, {});
  
    // Verifica si la localidad existe y tiene menos de 3 caracteres
    const localidad = cleanFiltros.localidad;
    if (localidad && localidad.length < 3) {
      console.log('La localidad debe tener al menos 3 caracteres para realizar la búsqueda.');
      return; // Detener la ejecución si hay menos de 3 caracteres
    }
  
    this.contactoService.getContactos(
      {
        page: this.page.pageIndex,
        pageSize: this.page.pageSize || 20
      },
      {
        sort: this.sort.active,
        order: this.sort.direction
      },
      cleanFiltros // Usa los filtros "limpios"
    ).subscribe(
      respuesta => {
        this.contactos = [];
        this.cargando = false;
        const data = this._cmSv.format(respuesta, false);
        if (respuesta.estado == 1 && respuesta.data) {
          this.total = respuesta.data.total;
          respuesta.data.contactos.forEach(contacto => {
            this.contactos.push(contacto);
          });
          this.contactosDataSource.data = this.contactos;
        }
  
        this.cargando = false; // Ocultar progress bar si se estaba mostrando
      },
      () => {
        this.cargando = false; // Ocultar progress bar si se estaba mostrando
      }
    );
  }
  
  descargarListado() {
    this.descargandolistado = true;
    this.contactoService.getContactos(
      {
        page: null,
        pageSize: null
      },
      {
        sort: this.sort.active,
        order: this.sort.direction
      },
      Object.assign(this.filtros)
    ).subscribe((data: any) => {
      const blobData = new Blob([data['archivo']], { type: 'text/csv' });
      saveAs(blobData, 'listado.csv');
      this.descargandolistado = false;
    });
  }

  fallaDescargarListado() {
    this.snackBar.open('Lo sentimos, no se pudo descargar el listado', 'OK', { duration: 4750 });
  }
}
